import Model from './Model'

export default class ItemIcon extends Model {

	/** @type number */ id
	/** @type string */ url
	/** @type string */ name

	constructor(attrs) {
		super(attrs)

		if (this.url[0] == '/') {
			this.url = `${window.ROOT_URL}${this.url}`
		}
	}
}
